export default {
  TRANSLATE_LANGUAGE: 'TRANSLATE_LANGUAGE'
}